export default "__VITE_ASSET__DDAHbmbj__"